import { DataLoadingView } from "../../../components";

import closeIcon from "../../../assets/icons/close-circle.svg";
import {
  // IReactQueryApiState,
  IViewHostedPaymentLink,
  IViewTransaction,
  IVirtualAccountTransferTimelineEntry,
} from "../../../interfaces-and-types";
import { transactionType } from "../../../enums";
import { useCheckoutPage, useMerchantApiQueryWithParams } from "../../../hooks";
import { useEffect, useState } from "react";
import { appConfig } from "../../../configs";
import { IIFrameRedirectMessage } from "../TransactionIFrame/TransactionIFrame";
import moment from "moment";

interface IVirtualBankTransferConfirmationPendingProps {
  hostedPaymentLink: IViewHostedPaymentLink;
  closeVirtualBankAccountsView: () => void;
  showSuccessPage: () => void;
}

// interface IVirtualBankTransferConfirmationPendingViewProps {
//   hostedPaymentLink: IViewHostedPaymentLink;
//   virtualAccountTransactionTimeline: IVirtualAccountTransferTimelineEntry[];
// }

export const VirtualBankTransferConfirmationPending = (
  props: IVirtualBankTransferConfirmationPendingProps
) => {
  const { closeVirtualBankAccountsView, hostedPaymentLink, showSuccessPage } =
    props;

  const closeVirtualBankAccountsViewWithConfirmation = () => {
    if (
      window.confirm(
        "Are you sure you want to close this window? Your transfer has not been confirmed!!!"
      )
    ) {
      closeVirtualBankAccountsView();
    }
  };

  const [transactionCompleted, setTransactionCompleted] = useState(false);

  // customer is now viewing the timeline events
  const [
    virtualAccountTransactionTimeline,
    setVirtualAccountTransactionTimeline,
  ] = useState<IVirtualAccountTransferTimelineEntry[]>([]);

  // hide/show the switcher when user enters/leaves view
  const { showPaymentMethodSwitcher, hidePaymentMethodSwitcher } =
    useCheckoutPage();

  useEffect(() => {
    hidePaymentMethodSwitcher();

    return () => showPaymentMethodSwitcher();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    isFetching,
    isSuccess,
    data: virtualTransferTransactionResponse,
  } = useMerchantApiQueryWithParams<
    { tx_ref: string; tx_type: transactionType },
    IViewTransaction
  >(
    [
      "checkVirtualTransferTransactionStatus",
      {
        tx_ref: hostedPaymentLink.tx_ref!,
        tx_type: hostedPaymentLink.is_top_up_payment_link
          ? transactionType.topUp
          : transactionType.payment,
      },
    ],
    {
      enabled: !transactionCompleted,
      refetchInterval: 20000, // refetch every 20 seconds
    }
  );

  // this comes into effect when tx is in processing state
  useEffect(() => {
    if (isSuccess) {
      // console.log(
      //   "running check on tx status, transaction: ",
      //   virtualTransferTransactionResponse
      // );

      switch (virtualTransferTransactionResponse?.status) {
        case "successful":
          performSuccessEvents({
            channel: "switchAppRedirectMessage",
            merchant_redirect_url:
              virtualTransferTransactionResponse.redirect_url,
            status: virtualTransferTransactionResponse.status,
            tx_ref: virtualTransferTransactionResponse.tx_ref,
          });
          break;

        case "failed":
          performFailedEvents({
            channel: "switchAppRedirectMessage",
            merchant_redirect_url:
              virtualTransferTransactionResponse.redirect_url,
            status: virtualTransferTransactionResponse.status,
            tx_ref: virtualTransferTransactionResponse.tx_ref,
          });
          break;

        default:
          // display timeline
          if (
            virtualTransferTransactionResponse !== null &&
            virtualTransferTransactionResponse
              ?.virtual_account_transfer_timeline_entries.length
          ) {
            setVirtualAccountTransactionTimeline(
              virtualTransferTransactionResponse?.virtual_account_transfer_timeline_entries
            );
          }
          break;
      }
    }
  }, [isFetching, isSuccess]); // NOTE: isFetching is added to force a re-render

  // const [iframeLoading, setWaitForIframeLoad] = useState(true);
  // useEffect(() => {
  //   if (iframeLoading) {
  //     setTimeout(() => {
  //       setWaitForIframeLoad(false);
  //     }, 1000);
  //   }
  // }, [iframeLoading]);

  // close modal when transaction is completed and redirect to merchant
  const onPaymentSuccessful = () => {
    setTransactionCompleted(true);
    showSuccessPage();
  };

  const onPaymentFailed = () => {
    setTransactionCompleted(true);
    showSuccessPage();
  };

  const performSuccessEvents = (data: IIFrameRedirectMessage) => {
    onPaymentSuccessful();

    // get the tx from API and send to client modal

    setTimeout(() => {
      (window as any).parent.postMessage(
        {
          switchappId: "switchapp-inline-message",
          action: "callFunction",
          targetFunction: "onSuccess",
          params: data, // "payment.successful",
        },
        "*"
      );

      if (data.merchant_redirect_url)
        window.location.href = `${data.merchant_redirect_url}?tx_ref=${data.tx_ref}&status=${data.status}`;
    }, appConfig.merchantRedirectDelayMs); // redirect to merchant after a brief delay
  };

  const performFailedEvents = (data: IIFrameRedirectMessage) => {
    onPaymentFailed();

    // get the tx from API and send to client modal

    (window as any).parent.postMessage(
      {
        switchappId: "switchapp-inline-message",
        action: "callFunction",
        targetFunction: "onFailure",
        params: data, // "payment.failed",
      },
      "*"
    );
  };

  return (
    <div>
      <div className="flex-container justify-content--between align-items--center mt-5">
        <button
          className="close-bankaccounts--button"
          onClick={closeVirtualBankAccountsViewWithConfirmation}
          title="close and try another payment provider"
          type="button"
        >
          <img
            src={closeIcon}
            alt="close page"
            className="close-iframe--icon"
          />
        </button>
        <h6 className="ml-5">Checking bank transfer status. Please wait...</h6>
      </div>

      <div className="flex-container col align-items--center guide-container bordered pt-5 pb-5">
        <strong className="text-danger">
          Bank transfers can take between 2 and 20 minutes
        </strong>
      </div>

      <div className="flex-container col justify-content--center w-100 align-items--stretch mt-5 mb-5">
        <DataLoadingView
          message="Please, do not close this window. Checking transaction status..."
          className="font-ctm--bold"
        />
      </div>

      <div
        className={`gateway-links--container col heavy-padding-${
          3 -
          (virtualTransferTransactionResponse
            ?.virtual_account_transfer_timeline_entries?.length || 0)
        }`}
      >
        {/* {virtualTransferTransactionResponse?.virtual_account_transfer_timeline_entries?.map( */}
        {virtualAccountTransactionTimeline?.map((evt, index) => (
          <div
            key={evt.id}
            className={`transfer-event-container bordered pl-5 pt-5 pb-5 b-r-5 mt-5 mb-5 animated-item-${index}`}
          >
            <div className="float-right mt-n3 mr-3">
              {/* <Badge
                  text={evt.gateway_code}
                  statusColor={"primary"}
                  hideIndicator
                /> */}
              <span className="">
                <img
                  alt="gateway"
                  src={`/gateway-logos/${evt.gateway_code}-icon.svg`}
                  className="gateway-icon--small"
                  title={evt.gateway_code}
                />
                {/* {tx.gateway_code} */}
              </span>
            </div>
            <div className="mb-3 font-ctm--bold">
              <strong>{evt.action.toUpperCase()}</strong>
            </div>
            <div className="mb-5 text-secondary">
              <strong>{evt.description}</strong>
            </div>
            <div>
              <strong className="date--oneline switchapp-small text-secondary">
                {moment(evt.created_at).format(appConfig.dateTimeFormat)}
              </strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
